module.exports = __webpack_public_path__ + "img/weixin.6888f7f4.png";